export interface IGetDriverByIdFiltersDto {
    tripId?: string;
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
